import { render, staticRenderFns } from "./BlockSection.vue?vue&type=template&id=d5551558&scoped=true&"
import script from "./BlockSection.vue?vue&type=script&lang=js&"
export * from "./BlockSection.vue?vue&type=script&lang=js&"
import style0 from "./BlockSection.vue?vue&type=style&index=0&id=d5551558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5551558",
  null
  
)

export default component.exports